import { DataService } from 'src/app/modules/shared/services';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../screens/auth/services/auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router, public dataService: DataService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    //Only apply the restriction to the "consultation-review" route
    if (state.url.startsWith('/consultation-review')) {
      const user = this.dataService.userDetails;

    //Block access if unit_level or unit is missing (null/undefined) OR equals 0
      if (
        user?.unit_level == null || 
        user?.unit == null || 
        user?.unit_level == 0 || 
        user?.unit == 0
      ) {
        this.router.navigate(['/unauthorized']);
        return false;
      }
    }

    // Allow access to routes starting with 'feedback' without authentication
    if (state.url.startsWith('/feedback')) {
      return true;
    }

    if (state.url.startsWith('/consent')) {
      return true;
    }
    
    if (this.auth.currentUserValue) {
      if (state.url === "/login") {
        this.auth.redirectAsperPermission();
      }
      return true;
    } else {
      if (state.url !== "/login") {
        this.router.navigate(['/login']);
      }
      return true;
    }
  }

}
